const p1 = [
    [6, 0],
    [6, 6],
    [2, 8],
    [2, 16],
    [6, 18],
    [6, 34],
    [2, 36],
    [2, 38],
    [6, 40],
    [6, 46],
    [10, 48],
    [10, 53],
    [10, 55, true, 1],
    [48, 74],
    [98, 49, true, 2],
    [98, 30],
    [90, 34],
    [90, 28],
    [94, 26],
    [94, 16],
    [90, 14],
    [90, 8],
    [98, 12],
    [98, 0],
];

const p1b = [
    [10, 53],
    [10, 55],
    [2, 51],
    [2, 100],
]

const p1c = [
    [98, 50],
    [98, 77],
    [90, 73],
    [90, 79],
    [94, 81],
    [94, 100],
]

const p1d = [
    [10, 54],
    [10, 55],
    [12, 56],
]

const p2 = [
    [2, 0],
    [2, 6],
    [6, 8],
    [6, 16],
    [2, 18],
    [2, 34],
    [6, 36],
    [6, 38],
    [2, 40],
    [2, 47],
    [6, 49],
    [6, 56],
    [10, 58, true, 4],
    [42, 74],
    [88, 51, true, 5],
    [94, 48],
    [94, 29],
    [98, 27],
    [98, 15],
    [94, 13],
    [94, 0],
]

const p2b = [
    [10, 58],
    [10, 61],
    [6, 59],
    [6, 100],
]

const p2c = [
    [90, 49],
    [90, 55],
    [94, 53],
    [94, 77],
    [98, 79],
    [98, 100],
]
const x1 = [
    [6, 3],
    [6, 6],
    [2, 8],
    [2, 9],
]

const x2 = [
    [6, 13],
    [6, 16],
    [2, 18],
    [2, 19],
]

const x3 = [
    [6, 33],
    [6, 34],
    [2, 36],
    [2, 37],
]

const x4 = [
    [6, 37],
    [6, 38],
    [2, 40],
    [2, 41],
]

const x5 = [
    [12, 56],
    [2, 51],
    [2, 100],
]

const x6 = [
    [38, 72],
    [42, 74],
    [50, 70],
]

const x7 = [
    [86, 55],
    [94, 51],
]

const x8 = [
    [94, 59],
    [94, 77],
    [98, 79],
    [98, 100],
]

const x9 = [
    [98, 35],
    [98, 30],
    [90, 34],
    [90, 32],
]
const x10 = [
    [94, 12],
    [94, 4],
]

const clippedPath = [
    [6, 0],
    [6, 6],
    [4, 7],
    [6, 8],
    [6, 16],
    [4, 17],
    [6, 18],
    [6, 34],
    [4, 35],
    [6, 36],
    [6, 38],
    [4, 39],
    [6, 40],
    [6, 46],
    [10, 48],
    [10, 55],
    [48, 74],
    [46, 72],
    [48, 71],
    [94, 48],
    [94, 31],
    [90, 33],
    [90, 28],
    [94, 26],
    [94, 16, true],
    [90, 14, true],
    [90, 8],
    [94, 10],
    [94, 0],
]
const clipped2 = [
    [94, 100],
    [94, 81],
    [90, 79],
    [90, 73, true],
    [94, 75, true],
    [94, 53, true],
    [90, 55, true],
    [90, 53],
    [48, 74],
    [45, 72, true],
    [42, 74],
    [10, 58],
    [10, 61, true],
    [6, 59, true],
    [6, 100],
]

export default { p1, p1b, p1c, p1d, p2, p2b, p2c, x1, x2, x3, x4, x5, x6, x7, x8, x9, x10, clippedPath, clipped2 }